import React from "react";
import { cn } from "../../lib/cn";
import { PrimaryLink } from "./Buttons";
import { PHONE_TEL } from "../../lib/businessInfo";

/**
 * Primary-styled tel link for conversions.
 */
export default function CallButton({ className, ...rest }) {
  return (
    <PrimaryLink
      href={PHONE_TEL}
      data-gtm="phone-click"
      className={cn("w-full sm:w-auto", className)}
      {...rest}
    >
      Call Now
    </PrimaryLink>
  );
}
